import { useSelector } from "react-redux";

import { AdminLabOrderList, LabOrder } from "pwapi";

import {
  ExternalLabStainsState,
  ExternalLabsState,
  LabStainsState,
} from "../reducers/frontLoaderReducers";
import { appendSendoutIfNeeded } from "../utils/labUtils";

const useLabOrderExternalLabNames = (
  labOrder: LabOrder | AdminLabOrderList
) => {
  const labStain = useSelector(
    ({ labStains }: { labStains: LabStainsState }) =>
      labStains[labOrder.lab_stain_id || 0]
  );
  const externalLabStain = useSelector(
    ({ externalLabStains }: { externalLabStains: ExternalLabStainsState }) =>
      externalLabStains[labStain.external_lab_stain_id || 0]
  );
  const externalLab = useSelector(
    ({ externalLabs }: { externalLabs: ExternalLabsState }) =>
      externalLabs[externalLabStain?.external_lab_id || 0]
  );

  return appendSendoutIfNeeded(externalLab?.name);
};

export default useLabOrderExternalLabNames;
